// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QRScan_reader__W4yjD {
  width: 100%;
  height: 100%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
}

.QRScan_video__J1ieb {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: relative;
}

.QRScan_box__1fuob {
  width: 100% !important;
  left: 0 !important;
}

.QRScan_frame__CIcnw {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  color: var(--white);
}

.QRScan_loader__\\+XZL0 {
  background: black;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}
.QRScan_loader__\\+XZL0 img {
  width: 100px;
}

.QRScan_scaner-container__GCFmR {
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  width: 100dvw;
  min-height: 100dvh;
  min-width: 100dvw;
}
.QRScan_scaner-container__GCFmR video {
  height: 100% !important;
  width: 100% !important;
  object-fit: cover;
}

.QRScan_scannerhtml5__C7pCr {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.QRScan_scannerhtml5__load__sBJQ- {
  opacity: 0;
  visibility: hidden;
}

.QRScan_loadFile__lSkHa {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
.QRScan_loadFile__box__QcKc8 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.48);
}
.QRScan_loadFile__label__LZPY7 {
  color: var(--white);
  text-align: center;
  font-size: 16px;
  line-height: 18px;
}
.QRScan_loadFile__btn__-L94u {
  background: var(--white);
  color: var(--text-color);
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 1;
  border-radius: 12px;
  margin-top: 16px;
}
.QRScan_loadFile__btn__-L94u input {
  display: none;
}
.QRScan_loadFile__icon__GI7vH {
  margin-right: 4px;
}

.QRScan_testError__clVD4 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999999;
  background: white;
  color: var(--text-color);
  font-size: 14px;
  padding-top: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/QRScan/QRScan.module.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,sBAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,4CAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,aAAA;EACA,cAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;AAAF;AAEE;EACE,uBAAA;EACA,sBAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AADF;AAGE;EACE,UAAA;EACA,kBAAA;AADJ;;AAKA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;AAFF;AAIE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,qCAAA;AAFJ;AAKE;EACE,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;AAHJ;AAME;EACE,wBAAA;EACA,wBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,aAAA;AAJN;AAQE;EACE,iBAAA;AANJ;;AAWA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;AARF","sourcesContent":[".reader {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0 auto;\r\n  position: relative;\r\n  overflow: hidden;\r\n}\r\n\r\n.video {\r\n  width: 100%;\r\n  height: 100%;\r\n  object-fit: cover;\r\n  position: relative;\r\n}\r\n\r\n.box {\r\n  width: 100% !important;\r\n  left: 0 !important;\r\n}\r\n\r\n.frame {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 50%;\r\n  transform: translateX(-50%) translateY(-50%);\r\n  color: var(--white);\r\n}\r\n\r\n.loader {\r\n  background: black;\r\n  position: absolute;\r\n  z-index: 1;\r\n  width: 100%;\r\n  height: 50%;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  img {\r\n    width: 100px;\r\n  }\r\n}\r\n\r\n.scaner-container {\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  width: 100vw;\r\n  width: 100dvw;\r\n  min-height: 100dvh;\r\n  min-width: 100dvw;\r\n\r\n  & video {\r\n    height: 100% !important;\r\n    width: 100% !important;\r\n    object-fit: cover;\r\n  }\r\n}\r\n\r\n.scannerhtml5 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  height: 100%;\r\n\r\n  &__load {\r\n    opacity: 0;\r\n    visibility: hidden;\r\n  }\r\n}\r\n\r\n.loadFile {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 100%;\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 16px;\r\n\r\n  &__box {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 12px;\r\n    border-radius: 12px;\r\n    background-color: rgba(0, 0, 0, 0.48);\r\n  }\r\n\r\n  &__label {\r\n    color: var(--white);\r\n    text-align: center;\r\n    font-size: 16px;\r\n    line-height: 18px;\r\n  }\r\n\r\n  &__btn {\r\n    background: var(--white);\r\n    color: var(--text-color);\r\n    padding: 12px 16px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 600;\r\n    line-height: 1;\r\n    border-radius: 12px;\r\n    margin-top: 16px;\r\n\r\n    & input {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  &__icon {\r\n    margin-right: 4px;\r\n  }\r\n}\r\n\r\n\r\n.testError {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  z-index: 9999999;\r\n  background: white;\r\n  color: var(--text-color);\r\n  font-size: 14px;\r\n  padding-top: 15px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reader": `QRScan_reader__W4yjD`,
	"video": `QRScan_video__J1ieb`,
	"box": `QRScan_box__1fuob`,
	"frame": `QRScan_frame__CIcnw`,
	"loader": `QRScan_loader__+XZL0`,
	"scaner-container": `QRScan_scaner-container__GCFmR`,
	"scannerhtml5": `QRScan_scannerhtml5__C7pCr`,
	"scannerhtml5__load": `QRScan_scannerhtml5__load__sBJQ-`,
	"loadFile": `QRScan_loadFile__lSkHa`,
	"loadFile__box": `QRScan_loadFile__box__QcKc8`,
	"loadFile__label": `QRScan_loadFile__label__LZPY7`,
	"loadFile__btn": `QRScan_loadFile__btn__-L94u`,
	"loadFile__icon": `QRScan_loadFile__icon__GI7vH`,
	"testError": `QRScan_testError__clVD4`
};
export default ___CSS_LOADER_EXPORT___;
